import { FilterDropdown, FilterWrapper } from "@/components/styled";
import { useProjectNumberSuggestQuery } from "@/services";
import { Button, Select, Space, Spin } from "antd";
import DOMPurify from "dompurify";
import { arrayOf, func, object, string } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";

const { Option } = Select;

const ProjectNumberSearchFilter = ({
  inputRef,
  onSearch,
  onReset,
  confirm,
  defaultValue,
  userId,
}) => {
  const intl = useIntl();
  const [suggestValue, setSuggestValue] = useState();
  const [selectedValues, setSelectedValues] = useState(defaultValue);

  const { data: projectNumberSuggests, isLoading } =
    useProjectNumberSuggestQuery(
      {
        projectNumber: suggestValue,
        userId: userId,
      },
      {
        skip: !suggestValue,
      }
    );

  const handleReset = () => {
    setSuggestValue();
    setSelectedValues();
    confirm();
    onReset();
  };

  const handleSuggest = (value) => {
    setSuggestValue(value);
  };

  const handleSearch = (selectedValue) => {
    setSelectedValues(selectedValue);
    onSearch(selectedValue);
  };

  return (
    <FilterWrapper>
      <FilterDropdown
        ref={inputRef}
        mode="multiple"
        showSearch
        defaultActiveFirstOption={false}
        optionLabelProp="label"
        filterOption={false}
        allowClear
        data-test-id="filter-dropdown"
        placeholder={intl.formatMessage({
          id: "tableFilters.dropDownPlaceholder",
        })}
        value={selectedValues}
        onSearch={handleSuggest}
        onChange={handleSearch}
        notFoundContent={isLoading ? <Spin size="small" /> : null}
      >
        {projectNumberSuggests?.map(({ projectNumber }) => (
          <Option key={projectNumber}>
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(projectNumber),
              }}
            />
          </Option>
        ))}
      </FilterDropdown>
      <Space>
        <Button data-test-id="reset-button" onClick={handleReset} size="small">
          {intl.formatMessage({ id: "general.reset" })}
        </Button>
      </Space>
    </FilterWrapper>
  );
};

ProjectNumberSearchFilter.propTypes = {
  inputRef: object,
  onSearch: func,
  onReset: func,
  confirm: func,
  defaultValue: arrayOf(string),
  userId: string,
};

export default ProjectNumberSearchFilter;
